@let workflowOrigin = this.workflowOrigin();
@let projectName = this.projectName();

@if (workflowOrigin !== workflowOriginEnum.Configurator) {
    <warema-svg-icon class="back-icon" filePath="assets/images/icons/icon_back.svg" height="11" width="17" />
}

@if (workflowOrigin === workflowOriginEnum.WaremaPlusProjects) {
    <!-- eslint-disable @nx/workspace-ebiz-no-inner-html -->
    <div
        class="label"
        tabindex="0"
        [innerHtml]="'APPOINTMENT_REQUEST.BACK_TO_PROJECTS' | translate: { projectName: projectName }"
    ></div>
    <!-- eslint-enable @nx/workspace-ebiz-no-inner-html -->
} @else {
    @if (workflowOrigin !== workflowOriginEnum.Configurator) {
        <!-- eslint-disable @nx/workspace-ebiz-no-inner-html -->
        <div
            class="label appointments"
            tabindex="0"
            [innerHtml]="'APPOINTMENT_REQUEST.BACK_TO_APPOINTMENTS' | translate"
        ></div>
        <!-- eslint-enable @nx/workspace-ebiz-no-inner-html -->
    }
}
